import { Platform, View } from 'react-native';

import gs from '@app/styles/globalStyles';
import ProfileIcon from '../../../../../assets/Icons/Profile';
import ROUTE from '@app/navigationApp/routes';
import NeedHelp from '@sharedComponents/NeedHelp/NeedHelp';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import ThemedTouchableOpacity from '@app/theme/Components/ThemedTouchableOpacity';
import { Theme, ThemedText, ThemedView } from '@app/theme'
import { isFromAndroidWebview, useDarkMode } from '@app/utils';
import BackButton from '@app/sharedComponents/BackButton/BackButton';
import { useTheme } from '@shopify/restyle';


type DashboardHeaderProps = {
  navigation : NativeStackNavigationProp<PrivateStackParamList>,
  name : string
  showMyAccountIcon: boolean
  callDataVisible: boolean
  isfromTDL?: boolean
}


const DashboardHeader = ({ navigation,callDataVisible, name, showMyAccountIcon = true,isfromTDL=false }: DashboardHeaderProps) => {
  const welcome = callDataVisible ? name?.length <=10 ? 'Welcome, ' : 'Welcome!' : 'Welcome'
  const isDarkMode = useDarkMode();

  const {colors} = useTheme<Theme>()

  const tdlHandler = () => {
    console.warn("BACK BUTTON CLICKED")
    window?.parent?.postMessage("Exit callback","*")
    if(isFromAndroidWebview()){
        window.open("closeActivity", "_parent")
    }
  // @ts-ignore
  window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity"); 
  }
  return (
    <ThemedView
      bg='bg-surface-primary'
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      paddingHorizontal='lg'
      height={60}
      style={[
      ]}>
     {isfromTDL ?
     <ThemedView mr="sm">
          <BackButton navigation={navigation} manualHandle={tdlHandler}/>
          </ThemedView>:
     <ThemedView style={[gs.flexRow]}>
          <ThemedText color='text-primary' variant='h5s'>{welcome}</ThemedText>
        {callDataVisible && (name !== '' && name?.length <= 10)  && (
           <ThemedText color='text-action-primary' variant='h5s'>{name}</ThemedText>
        )}
      </ThemedView>}
      <ThemedView style={[gs.flexRow]}>
        <NeedHelp callDataVisible={callDataVisible} />
        {showMyAccountIcon && !isfromTDL &&
          <ThemedTouchableOpacity
            eventName="USER_ACCOUNT_ICON"
            hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }}
            ml='md'
            onPress={() => {
              navigation.navigate(ROUTE.USER_PROFILE);
            }}>
            <ProfileIcon color={colors['icon-action-primary']} bgColor={colors['bg-fill-emphasis-primary-1']}/>
          </ThemedTouchableOpacity>}
      </ThemedView>
    </ThemedView>
  );
};

export default DashboardHeader;
